export enum BannerAlertType {
  informational = 'informational',
  success = 'success',
  error = 'error',
  caution = 'caution',
}
